var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiberar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.006,
    height: 14.004,
    viewBox: "0 0 22.006 14.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "liberar",
    d: "M13.66,19a1,1,0,0,1-.71-.29l-6-6a1,1,0,0,1,0-1.42l6-6a1,1,0,1,1,1.41,1.42L10.07,11H22a1,1,0,0,1,0,2H10.07l4.29,4.29a1,1,0,0,1-.7,1.71ZM8,19a1,1,0,0,1-.71-.29l-6-6a1,1,0,0,1,0-1.42l6-6A1,1,0,0,1,8.71,6.71L3.41,12l5.3,5.29A1,1,0,0,1,8,19Z",
    transform: "translate(23 19) rotate(180)",
    fill: "#7a004b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberar);
export default __webpack_public_path__ + "static/media/liberar.a125fb1da7b8074831f77bcf573c6cca.svg";
export { ForwardRef as ReactComponent };